import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import { t } from "i18next";
import { useEffect, useState, useRef } from "react";
import "./ThemeModal.scss";
import { AddKnowledgeBase } from "../AddKnowledgeBaseSection/addknowledgebase.js";
import HtmlPreview from "./IsValidHtml.js";

const ThemeModal = ({
  modelSize = "xl",
  Heading = "Select Your Prompt",
  show = false,
  onClose ,
  list = [],
  html = null,
  AddKnowledgeBaseData,
  setPrompt ,
  checkPrompt,
  loading
}) => {
  const Link = ({ id, children, title }) => (
    // <OverlayTrigger
    //   placement="left"
    //   overlay={<Tooltip id={id}>{title}</Tooltip>}
    // >
    <span className="nav-item">{children}</span>
    // </OverlayTrigger>
  );
  const [tableName, setTableName] = useState("");
  const [error, setError] = useState("");
  const handleOnChange = (value) => {};
  useEffect(() => {
    if (Heading == "KB") {
      setTableName("");
    }
  }, [show]);
  return (
    <Modal
      className={`${(Heading == "Delete")?'delete-modal':"custom-modal"}`}
      show={show}
      size={modelSize}
      centered
      onHide={() => onClose()}
    >
      {Heading != "KB" &&
        // && Heading != "Delete"
        Heading != "AddKB" && (
          <Modal.Header closeButton>
            {Heading == "Delete" ? (
              <div className="ionbx">
                <img src="/images/bin.svg" />
              </div>
            ) : (
              <h4>{Heading}</h4>
            )}
          </Modal.Header>
        )}
      <Modal.Body className={`${(Heading == "Delete")?'pt-0':'custom-body-modal knowledgemodal'}`}>
        {html == "" && (
          <Container className="conclass">
            {list.map((data, index) => {
              return (
                <Row style={{ marginBottom: "10px" }}>
                  <Col xs={9}>{data?.msgChunks}</Col>
                  <Col>
                    <Button
                      key={index}
                      variant="primary"
                      style={{ backgroundColor: "#0061AF" }}
                      onClick={() => {
                        setPrompt(data);
                        onClose();
                      }}
                    >
                      Send
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </Container>
        )}
      {html && html.trim() !== "" && <HtmlPreview html={html}  />}
        {Heading == "KB" && (
          <div className="d-flex gap-3 infermodal-wrapper">
            <div className="icon-kn">
              <img src="/images/book.svg" alt="Knowledge Base" />
            </div>
            <div className="right-inenr-wrap">
              <div className="heading-box">
                <div className="instruct-title">
                  <div className="name-infowrap">
                    <span className="name-box">{t("addknowledge")}</span>
                    <p className="disc-title">{t("addknowledgepara1")}</p>
                  </div>
                </div>
                <div className="d-flex aling-items-center gap-5">
                  <Link
                    id="t-2"
                    title={`${t("knowledgeOverlay1")} ${t(
                      "knowledgeOverlay2"
                    )}`}
                  >
                    <img src="/images/questionbuble.svg" />
                  </Link>
                  <span className="close cursor-pointer" onClick={onClose}>
                    <img src="/images/themecross.svg" />
                  </span>
                </div>
              </div>

              <div className="input-wrap-row-wrap">
                <div className="from-input-wrapper">
                  <div className="input-wrap-row-wrap">
                    <div className="from-input-wrapper">
                      <div className="from-input-wrapper">
                        <label htmlFor="name">
                          {t("firstCreateTable")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center frm-pop gap-3">
                          <input
                            id="name"
                            placeholder={t("enterTableName")}
                            className="form-control"
                            value={tableName}
                            onChange={async (e) => {
                              setTableName(e.target.value);

                              let isExist = false;
                              if (e.target.value != "") {
                                isExist = await checkPrompt(e.target.value);
                              }
                              if (isExist) {
                                setError(
                                  `${e.target.value} table already exist`
                                );
                              } else {
                                setError("");
                              }
                              // let alreadyExist =
                              //   e.target.value != ""
                              //     ? await
                              //     : false;
                              //   console.log(alreadyExist)
                              // if (alreadyExist) {

                              //   setTimeout(() => setError("#"), 3000);
                              // } else {
                              //   setError("");
                              // }
                            }}
                            required
                          />
                        </div>
                      </div>
                      {error && error != "#" && (
                        <span style={{ color: "red" }}>{error}</span>
                      )}
                      <div className="d-flex gap-2 align-items-center msg-box justify-content-between mb-0">
                        <div className="kb-message">
                          {t("addknowledgepara2")}
                        </div>
                        <button
                          className="add-input-btn"
                          style={
                            tableName == "" || error
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                          onClick={() => {
                            setPrompt(tableName);
                            setTableName("");
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M9.99996 4.16675V15.8334M4.16663 10.0001H15.8333"
                              stroke="#0061AF"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Create Table
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {Heading == "Delete" && (
          // <div className="d-flex gap-3 infermodal-wrapper">
          //   <div className="icon-kn">
          //     <img src="/images/delete.svg" />
          //   </div>
          //   <div className="right-inenr-wrap">
          //     <div className="heading-box">
          //       <div className="instruct-title">
          //         <div className="name-infowrap">
          //           <span className="name-box">{t("removefilefromtable")}</span>
          //           <p className="disc-title">
          //             {t("removefilefromtabledetail")}
          //           </p>
          //         </div>
          //       </div>
          //       <div className="d-flex aling-items-center gap-5">
          //         <span className="close cursor-pointer" onClick={onClose}>
          //           <svg
          //             xmlns="http://www.w3.org/2000/svg"
          //             width="24"
          //             height="24"
          //             viewBox="0 0 24 24"
          //             fill="none"
          //           >
          //             <path
          //               d="M18 6L6 18M6 6L18 18"
          //               stroke="#6941C6"
          //               stroke-width="2"
          //               stroke-linecap="round"
          //               stroke-linejoin="round"
          //             />
          //           </svg>
          //         </span>
          //       </div>
          //     </div>

          //     <div className="input-wrap-row-wrap">
          //       <div className="from-input-wrapper">
          //         <div className="input-wrap-row-wrap">
          //           <div className="from-input-wrapper">
          //             {/* <div className="from-input-wrapper">
          //               <label htmlFor="name">
          //                 {t("firstCreateTable")}
          //                 <span style={{ color: "red" }}>*</span>
          //               </label>
          //               <div className="d-flex align-items-center frm-pop gap-3">
          //               <input
          //                 id="name"
          //                 placeholder={t("enterTableName")}
          //                 className="form-control"
          //                 value={tableName}
          //                 onChange={async(e)=>{
          //                   setTableName(e.target.value)
          //                   let alreadyExist=e.target.value!=''?await checkPrompt(e.target.value):false;
          //                   if(alreadyExist){
          //                     setError(`${e.target.value} table already exist`);
          //                     setTimeout(()=>setError('#'),3000);
          //                   }else{
          //                     setError('');
          //                   }
          //                 }}
          //                 required
          //               />
          //               </div>
          //             </div>
          //             {error&&error!='#'&&<span style={{color:'red'}}>{error}</span>} */}
          //             <div className="d-flex gap-2 align-items-center msg-box justify-content-between mb-0">
          //               {/* <div className="kb-message">
          //               {t('addknowledgepara2')}
          //               </div> */}
          //               <button
          //                 className="add-input-btn"
          //                 onClick={() => setPrompt(false)}
          //               >
          //                 {t("cancel")}
          //               </button>
          //               <button
          //                 className="add-input-btn"
          //                 onClick={() => setPrompt(true)}
          //               >
          //                 {t("removebtn")}
          //               </button>
          //             </div>
          //           </div>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div>
          <>
          <div className="modal-headerd">{t("removefilefromtable")}</div>
          <div className="deltemsg">{t("removefilefromtabledetail")}</div>
          </>

        )}
        {Heading == "AddKB" && (
          <AddKnowledgeBase {...AddKnowledgeBaseData} onClose={onClose} />
        )}
      </Modal.Body>
      {Heading == "Delete"&&<Modal.Footer className="justify-content-center flex-nowrap border-0 pt-3">
          <button className="cancelbtn" onClick={() => setPrompt(false)}>{t("cancel")}</button>
          <button className="deletebtn" onClick={() => setPrompt(true)} disabled={loading}>
          {loading ? (
            <Spinner
              animation="border"
              style={{ width: "16px", height: "16px" }}
            />
          ) : (
            t("removebtn")
          )}
        </button>
        </Modal.Footer>}
    </Modal>
  );
};
export default ThemeModal;
